import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const PolygonCoverage = () => {
	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'id',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'dcSettingsID',
				accessor: 'dcSettingsID',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'polygonName',
				accessor: 'polygonName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'connectionName',
				accessor: 'connectionName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'integrationName',
				accessor: 'integrationName',
				filterType: FilterType.multiSelection,
				showOnMobile: true
			},
			{
				Header: 'polygon',
				accessor: 'polygon',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'country',
				accessor: 'country',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				renderCell: ListComponents.COUNTRY,
				showOnMobile: true,
				filterPrefix: 'country.'
			},
			{
				Header: 'city',
				accessor: 'city',
				filterType: FilterType.multiSelection,
				showOnMobile: true
			},
			{
				Header: 'cityID',
				accessor: 'cityID',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'createdBy',
				accessor: 'createdBy',
				filterType: FilterType.string
			}
		],
		[]
	);

	return (
		<>
			<DynamicList
				id={DYNAMICLISTS.POLYGON_COVERAGE}
				columns={columns}
				fetchUrl={ADMIN.DELIVERY_COMPANY_SETTINGS.GET_POLYGON_COVERAGE_LIST}
				exportName="polygonCoverage"
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
			/>
		</>
	);
};

export default PolygonCoverage;
